import { render, staticRenderFns } from "./Combined-review.vue?vue&type=template&id=50266b36&scoped=true"
import script from "./Combined-review.vue?vue&type=script&lang=js"
export * from "./Combined-review.vue?vue&type=script&lang=js"
import style0 from "./Combined-review.vue?vue&type=style&index=0&id=50266b36&prod&lang=css"
import style1 from "./Combined-review.vue?vue&type=style&index=1&id=50266b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50266b36",
  null
  
)

export default component.exports